import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

interface Props {
  isSelected: boolean;
}

export const Container = styled.div<Props>`
  cursor: pointer;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: end;
  height: 105px;
  min-height: 105px;
  border-radius: 12px;
  border: ${(props: Props) =>
    props.isSelected ? `solid 2px ${ColorPalette.HEX.OutrageousOrange};` : `solid 1px ${ColorPalette.HEX.BrightGray}`};
  background-color: ${ColorPalette.HEX.White};
  padding: 24px 24px 24px 0;

  & + div {
    margin-top: 17px;
  }
`;

export const Icon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 56px;
  min-height: 56px;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  > h3 {
    font-family: Poppins;
    font-size: 16px;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: normal;
    color: ${ColorPalette.HEX.CharlestonGreen};

    > strong {
      color: ${ColorPalette.HEX.OriolesOrange};
    }
  }
  > p {
    font-family: Poppins;
    font-size: 12px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: normal;
    color: ${ColorPalette.HEX.DimGray};
  }
`;
